import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import lazyload from 'vue-lazyload'
import BootstrapVue from 'bootstrap-vue'
import VueMeta from 'vue-meta'
import vClickOutside from 'v-click-outside'
import VueScrollTo from 'vue-scrollto'

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles/app.scss'

Vue.component('pulse-loader', PulseLoader)

const lazyImage = require('./assets/images/_error.png')
Vue.use(lazyload, {
  error: lazyImage,
  loading: lazyImage
})
Vue.use(BootstrapVue)
Vue.use(VueMeta)
Vue.use(vClickOutside)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 100,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
